import { createContext, useContext } from 'react';

/**
 * In-app navigation for the Product Development full-screen views
 * (Project Analytics, Batch Genealogy, Gantt Chart, Executive Summary).
 *
 * These are rendered in place by ProductDevelopment (index.jsx) via local
 * state — they are NOT routed pages and have no URL. Entry points
 * (ActionButtons, ProjectTabs, TableSection) open them through this context
 * instead of pushing a route, so the browser URL never changes.
 *
 * Shape:
 *   openProjectAnalytics()                         → open the Project Analytics view
 *   openGanttChart()                               → open the Gantt Chart view
 *   openExecutiveSummary()                         → open the Executive Summary view
 *   openBatchGenealogy({ batchContext, fromProjectAnalytics }) → open Batch Genealogy
 *   openProjectTab(tabName, batchRef?)              → close any full-screen view and
 *                                                     select the named project tab
 *                                                     (e.g. "Deviations"). When
 *                                                     batchRef = { batchNumber,
 *                                                     campaignId } is given, the
 *                                                     dashboard's Campaign / CMO
 *                                                     Stage / CMO Batch selection is
 *                                                     first pointed at that batch so
 *                                                     the tab opens for it.
 */
export const ProjectDevNavContext = createContext({
  openProjectAnalytics: () => {},
  openBatchGenealogy: () => {},
  openGanttChart: () => {},
  openExecutiveSummary: () => {},
  openProjectTab: () => {},
});

export const useProjectDevNav = () => useContext(ProjectDevNavContext);
